import { Avatar, AvatarFallback } from '@/components/ui/avatar';

import { useCurrentUser } from '@/hooks/useCurrentUser';

import { ChangePassword } from './components/change-password';
import { ProfileDetail } from './components/profile-detail';
import { ProfileUpdate } from './components/profile-update';
import { AccountSkeleton } from './components/skeleton';

export default function Account() {
  const { userData } = useCurrentUser();
  const loading = false;

  const fullName = userData?.full_name;
  const initials = fullName
    ? fullName
        .split(' ')
        .map(n => n[0])
        .join('')
        .toUpperCase()
        .slice(0, 2)
    : '??';

  if (loading) {
    return <AccountSkeleton />;
  }

  return (
    <div className="mx-auto flex max-w-6xl flex-col space-y-4 p-4 pb-8 sm:space-y-4 sm:p-6 sm:pb-12">
      {/* Profile Header */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Avatar className="h-15 w-15" key={'no-main-avatar'}>
            <AvatarFallback className="text-xl font-medium bg-primary text-primary-foreground">
              {initials}
            </AvatarFallback>
          </Avatar>
          <div>
            <h1 className="text-2xl font-semibold">{fullName}</h1>
            <p className="text-muted-foreground">{userData?.role?.name}</p>
          </div>
        </div>

        <ProfileUpdate />
      </div>

      {/* Profile Details */}
      <ProfileDetail />

      {/* Security Section */}
      <ChangePassword />
    </div>
  );
}
